module.exports = __webpack_public_path__ + "assets/img/banner4.07c1608c.png";